import { Loader } from '@calendly/ui/components/loader'
import { Popup } from '@calendly/ui/components/popup'
import { useDispatch } from 'react-redux'

import { fetchCurrentSubscription } from 'features/billing/actions/fetch_current_subscription'
import { resetCreateSubscription } from 'features/billing/create_subscription_slice'

export const Loading = () => {
  const dispatch = useDispatch()

  const onClose = () => {
    dispatch(resetCreateSubscription())
    dispatch(fetchCurrentSubscription())
  }

  return (
    <Popup onClose={onClose}>
      <Loader />
    </Popup>
  )
}
